module.exports = __webpack_public_path__ + "static/media/printWhite.55fc77f9.svg";